import React, { useEffect, useState } from 'react';
import { CheckboxInput } from 'components/shared/Form';
import { GroupedPermission } from 'interfaces/group';
import * as S from './styles';

interface Props {
  configs: GroupedPermission;
  defaultValues?: any[];
  selectedModule?: string;
  namePrefix: string;
  label?: string;
}

export const ConfigChecklist: React.FC<Props> = ({
  configs,
  defaultValues = [],
  selectedModule,
  namePrefix,
  label,
}) => {
  const [checklist, setChecklist] = useState<GroupedPermission>({});

  useEffect(() => {
    if (configs) {
      setChecklist(configs);
    }
  }, [configs]);

  if (!selectedModule) {
    return null;
  }

  return (
    <>
      {label && <S.Title>{label}</S.Title>}
      <S.BoxContainer>
        {Object.entries(checklist).map(([domain, options]) => {
          const name = `${namePrefix}.${domain}`;

          return (
            <CheckboxInput
              key={domain}
              name={name}
              label={domain}
              options={options}
              defaultOptions={defaultValues}
              hideInList={
                !(
                  selectedModule &&
                  options[0]?.module_id === selectedModule
                )
              }
              direction="column"
            // fixWidth="165px"
            />
          );
        })}
      </S.BoxContainer>
    </>
  );
};
